import { render, staticRenderFns } from "./DicSelect.vue?vue&type=template&id=0942e4ff"
import script from "./DicSelect.vue?vue&type=script&lang=js"
export * from "./DicSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports